import { SxProps } from '@mui/material';

export const DpPopulateLinkSX: SxProps = {
	fontSize: 'var(--font-size-default)',
	fontWeight: 'normal',
	color: '#2C2C2C',
	lineHeight: '32px',
	cursor: 'pointer',
	'&:hover': {
		color: 'primary.main',
	},
};

export const DpPopulateCategorySX: SxProps = {
	fontSize: 'var(--font-size-lg)',
	fontWeight: 'bold',
	color: '#2C2C2C',
	textTransform: 'uppercase',
	marginBottom: '17px',
};

export const DpPopulateBlockDesktopFrameSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	justifyContent: 'flex-start',
};

export const DpPopulateUlSX: SxProps = {
	padding: 0,
	listStyleType: 'none',
	margin: 0,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
};

export const DpPopulateBlockMobileFrameSX: SxProps = {
	minWidth: '100%',
	width: '100%',
	borderBottom: '1px solid #D9D9D9',
	margin: '0px',
	overflow: 'hidden',
};

export const DpPopulateBlockMobileHeaderSX = (isExpanded: boolean): SxProps => ({
	borderBottom: isExpanded ? '1px solid #D9D9D9' : '',
	padding: '13px 0',
	cursor: 'pointer',
	userSelect: 'none',
	fontSize: 'var(--font-size-sm)',
	fontWeight: 800,
	color: '#2C2C2C',
	display: 'flex',
	justifyContent: 'space-between',
});

export const DpPopulateBlockMobileContentSX: SxProps = {
	padding: '10px 0',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'flex-start',
	alignItems: 'flex-start',
};
